var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPackagingImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 465,
    height: 440,
    viewBox: "0 0 465 440",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_409_1507)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_409_1507",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 465,
    height: 440
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M464.65 0H0V439.77H464.65V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_409_1507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.05 255.74C436.32 295.17 406.24 337.85 363.91 350.49C299.91 369.59 292.31 421.14 177.75 416.36C161.016 415.744 144.398 413.31 128.19 409.1C120.278 407.009 112.506 404.421 104.92 401.35C37.9905 374.24 3.08047 314.58 0.19047 252.16C-3.62953 170.05 53.6505 130.92 90.8805 108.01C128.11 85.1 172.98 -3.64999 285.63 0.120008C302.833 0.636146 319.919 3.13261 336.55 7.56001C374.46 17.82 412.99 40.51 435.39 73.68C437.07 76.18 438.677 78.7267 440.21 81.32C470.19 132.17 471.12 201.98 451.05 255.74Z",
    fill: "#92E3A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M451.05 255.74C436.32 295.17 406.24 337.85 363.91 350.49C299.91 369.59 292.31 421.14 177.75 416.36C161.016 415.744 144.398 413.31 128.19 409.1C120.278 407.009 112.506 404.421 104.92 401.35C37.9905 374.24 3.08047 314.58 0.19047 252.16C-3.62953 170.05 53.6505 130.92 90.8805 108.01C128.11 85.1 172.98 -3.64999 285.63 0.120008C302.833 0.636146 319.919 3.13261 336.55 7.56001C374.46 17.82 412.99 40.51 435.39 73.68C437.07 76.18 438.677 78.7267 440.21 81.32C470.19 132.17 471.12 201.98 451.05 255.74Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.04 439.25H462.32",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.33 21.3701H31.7598V232.95H187.33V21.3701Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.01 27.25H36.0801V227.08H183.01V27.25Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1201 37.6602H182.85",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1201 48.8701H182.85",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1201 60.0801H182.85",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1201 71.2803H182.85",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1201 82.4902H182.85",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1201 93.7002H182.85",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1201 104.91H182.85",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1201 116.12H182.85",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1201 127.32H182.85",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1201 138.53H182.85",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1201 149.74H182.85",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1201 160.95H182.85",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1201 172.16H182.85",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1201 183.36H182.85",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1201 194.57H182.85",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1201 205.78H182.85",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1201 216.99H182.85",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.21 21.3701H255.15V166.19H258.21V21.3701Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.5 21.3701H260.44V166.19H263.5V21.3701Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.04 21.3701H272.98V153.13H276.04V21.3701Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.02 21.3701H301.96V153.13H305.02V21.3701Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.8 21.3701H321.74V153.13H324.8V21.3701Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.701 21.3701H342.641V153.13H345.701V21.3701Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.27 21.3701H348.21V166.19H351.27V21.3701Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.84 21.3701H353.78V166.19H356.84V21.3701Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.181 21.3701H374.121V153.13H377.181V21.3701Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.36 21.3701H395.3V153.13H398.36V21.3701Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.701 21.3701H415.641V153.13H418.701V21.3701Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.56 21.3701H421.49V153.13H424.56V21.3701Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.04 21.3701H435.98V153.13H439.04V21.3701Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.17 21.3701H442.11V166.19H445.17V21.3701Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.02 21.3701H447.96V166.19H451.02V21.3701Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.841 21.3701H278.271V153.13H283.841V21.3701Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.76 21.3701H287.19V153.13H292.76V21.3701Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.951 21.3701H313.381V153.13H318.951V21.3701Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.441 21.3701H327.871V153.13H333.441V21.3701Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.55 21.3701H360.47V153.13H368.55V21.3701Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.61 21.3701H380.53V153.13H388.61V21.3701Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.51 21.3701H401.43V153.13H409.51V21.3701Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.07 181.6C279.982 181.656 278.902 181.384 277.97 180.82C277.182 180.286 276.589 179.51 276.28 178.61C275.905 177.537 275.725 176.406 275.75 175.27C275.733 174.441 275.831 173.613 276.04 172.81C276.199 172.226 276.46 171.674 276.81 171.18C277.102 170.787 277.461 170.449 277.87 170.18C278.237 169.935 278.618 169.711 279.01 169.51C278.102 169.138 277.332 168.491 276.81 167.66C276.203 166.619 275.912 165.424 275.97 164.22C275.954 163.221 276.124 162.227 276.47 161.29C276.785 160.463 277.361 159.761 278.11 159.29C279.02 158.765 280.062 158.515 281.11 158.57C282.144 158.518 283.17 158.772 284.06 159.3C284.784 159.789 285.342 160.487 285.66 161.3C286.008 162.244 286.177 163.244 286.16 164.25C286.224 165.439 285.939 166.621 285.34 167.65C284.812 168.47 284.049 169.111 283.15 169.49C283.541 169.689 283.918 169.913 284.28 170.16C284.667 170.436 285.005 170.774 285.28 171.16C285.634 171.655 285.901 172.206 286.07 172.79C286.288 173.591 286.389 174.42 286.37 175.25C286.395 176.386 286.216 177.517 285.84 178.59C285.532 179.488 284.943 180.262 284.16 180.8C283.233 181.368 282.157 181.647 281.07 181.6ZM281.07 179.99C281.724 180.022 282.37 179.839 282.91 179.47C283.433 179.082 283.816 178.534 284 177.91C284.453 176.247 284.453 174.493 284 172.83C283.828 172.188 283.482 171.607 283 171.15C282.456 170.693 281.771 170.435 281.06 170.42C280.331 170.433 279.627 170.69 279.06 171.15C278.555 171.598 278.188 172.181 278 172.83C277.772 173.623 277.664 174.445 277.68 175.27C277.652 176.165 277.781 177.059 278.06 177.91C278.243 178.55 278.642 179.107 279.189 179.486C279.736 179.865 280.397 180.043 281.06 179.99H281.07ZM281.07 168.55C281.737 168.56 282.385 168.333 282.9 167.91C283.356 167.491 283.683 166.949 283.84 166.35C284.029 165.632 284.12 164.892 284.11 164.15C284.184 163.1 283.932 162.052 283.39 161.15C283.117 160.804 282.762 160.532 282.357 160.357C281.952 160.182 281.51 160.111 281.07 160.15C280.627 160.111 280.18 160.181 279.77 160.356C279.36 160.53 279 160.803 278.72 161.15C278.163 162.047 277.904 163.097 277.98 164.15C277.969 164.893 278.063 165.634 278.26 166.35C278.424 166.961 278.773 167.506 279.26 167.91C279.775 168.32 280.412 168.545 281.07 168.55Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.83 181.6C296.851 181.634 295.878 181.435 294.99 181.02C294.235 180.638 293.63 180.015 293.27 179.25C292.863 178.331 292.658 177.335 292.67 176.33V175.92H294.67C294.579 176.987 294.82 178.056 295.36 178.98C295.912 179.478 296.605 179.792 297.344 179.878C298.082 179.964 298.829 179.818 299.48 179.46C299.991 179.086 300.361 178.551 300.53 177.94C300.8 177.001 300.921 176.026 300.89 175.05V170.79C300.52 171.186 300.07 171.5 299.57 171.71C298.84 172.004 298.057 172.144 297.27 172.12C296.244 172.182 295.224 171.934 294.34 171.41C293.591 170.88 293.056 170.1 292.83 169.21C292.502 167.961 292.354 166.671 292.39 165.38C292.364 164.148 292.547 162.921 292.93 161.75C293.242 160.795 293.848 159.962 294.66 159.37C295.58 158.763 296.669 158.465 297.77 158.52C298.836 158.465 299.891 158.764 300.77 159.37C301.567 159.982 302.151 160.828 302.44 161.79C302.822 163.013 303.001 164.29 302.97 165.57V174.57C302.992 175.805 302.824 177.036 302.47 178.22C302.198 179.189 301.641 180.053 300.87 180.7C299.993 181.346 298.918 181.665 297.83 181.6ZM297.75 170.53C298.443 170.563 299.132 170.414 299.75 170.1C300.187 169.875 300.583 169.578 300.92 169.22V165.35C300.948 164.34 300.84 163.331 300.6 162.35C300.485 161.706 300.135 161.129 299.617 160.729C299.1 160.33 298.452 160.138 297.8 160.19C297.152 160.166 296.513 160.345 295.97 160.7C295.444 161.095 295.058 161.649 294.87 162.28C294.607 163.148 294.486 164.053 294.51 164.96C294.495 165.994 294.566 167.028 294.72 168.05C294.8 168.749 295.118 169.398 295.62 169.89C296.23 170.352 296.986 170.579 297.75 170.53Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.76 181.35V174.74H308.96V172.65L315.37 158.74H317.77V172.88H320.36V174.72H317.77V181.35H315.76ZM311.02 172.9H315.76V161.44L311.02 172.9Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.89 181.35L331.3 160.35H324.46V158.71H333.39V159.71L328.87 181.35H326.89Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.71 181.6C370.585 181.663 369.47 181.361 368.53 180.74C367.741 180.143 367.157 179.314 366.86 178.37C366.513 177.26 366.345 176.103 366.36 174.94V165.12C366.339 163.952 366.514 162.789 366.88 161.68C367.183 160.742 367.779 159.925 368.58 159.35C369.511 158.753 370.606 158.463 371.71 158.52C372.831 158.457 373.943 158.747 374.89 159.35C375.686 159.929 376.277 160.744 376.58 161.68C376.941 162.791 377.117 163.953 377.1 165.12V174.94C377.119 176.114 376.947 177.282 376.59 178.4C376.302 179.343 375.716 180.168 374.92 180.75C373.968 181.367 372.843 181.665 371.71 181.6ZM371.71 179.99C372.436 180.031 373.151 179.795 373.71 179.33C374.203 178.854 374.55 178.247 374.71 177.58C374.91 176.772 375.008 175.942 375 175.11V164.99C375.009 164.158 374.911 163.328 374.71 162.52C374.549 161.854 374.202 161.247 373.71 160.77C373.142 160.323 372.432 160.096 371.71 160.13C370.987 160.086 370.273 160.315 369.71 160.77C369.211 161.242 368.864 161.851 368.71 162.52C368.5 163.326 368.4 164.157 368.41 164.99V175.11C368.401 175.943 368.502 176.774 368.71 177.58C368.862 178.25 369.211 178.859 369.71 179.33C370.268 179.797 370.984 180.034 371.71 179.99Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.92 181.6C387.795 181.664 386.68 181.362 385.74 180.74C384.948 180.145 384.364 179.316 384.07 178.37C383.718 177.262 383.549 176.103 383.57 174.94V165.12C383.55 163.953 383.723 162.791 384.08 161.68C384.383 160.742 384.979 159.925 385.78 159.35C386.744 158.806 387.833 158.52 388.94 158.52C390.047 158.52 391.136 158.806 392.1 159.35C392.893 159.929 393.481 160.745 393.78 161.68C394.146 162.789 394.322 163.952 394.3 165.12V174.94C394.317 176.113 394.148 177.28 393.8 178.4C393.508 179.341 392.923 180.164 392.13 180.75C391.177 181.365 390.053 181.662 388.92 181.6ZM388.92 179.99C389.647 180.032 390.362 179.796 390.92 179.33C391.417 178.857 391.765 178.248 391.92 177.58C392.129 176.774 392.23 175.943 392.22 175.11V164.99C392.231 164.157 392.13 163.326 391.92 162.52C391.767 161.851 391.419 161.242 390.92 160.77C390.334 160.36 389.636 160.14 388.92 160.14C388.205 160.14 387.507 160.36 386.92 160.77C386.425 161.245 386.077 161.852 385.92 162.52C385.719 163.328 385.621 164.158 385.63 164.99V175.11C385.623 175.942 385.72 176.772 385.92 177.58C386.073 178.25 386.421 178.859 386.92 179.33C387.477 179.8 388.193 180.037 388.92 179.99Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.12 181.6C404.995 181.663 403.88 181.361 402.94 180.74C402.151 180.143 401.568 179.314 401.27 178.37C400.923 177.26 400.755 176.103 400.77 174.94V165.12C400.749 163.952 400.925 162.789 401.29 161.68C401.593 160.742 402.189 159.925 402.99 159.35C403.921 158.753 405.016 158.463 406.12 158.52C407.241 158.457 408.353 158.747 409.3 159.35C410.096 159.929 410.688 160.744 410.99 161.68C411.351 162.791 411.527 163.953 411.51 165.12V174.94C411.529 176.114 411.357 177.282 411 178.4C410.712 179.343 410.126 180.168 409.33 180.75C408.378 181.367 407.253 181.665 406.12 181.6ZM406.12 179.99C406.846 180.031 407.561 179.795 408.12 179.33C408.614 178.854 408.96 178.247 409.12 177.58C409.32 176.772 409.418 175.942 409.41 175.11V164.99C409.419 164.158 409.322 163.328 409.12 162.52C408.959 161.854 408.613 161.247 408.12 160.77C407.553 160.323 406.842 160.096 406.12 160.13C405.397 160.086 404.684 160.315 404.12 160.77C403.622 161.242 403.274 161.851 403.12 162.52C402.911 163.326 402.81 164.157 402.82 164.99V175.11C402.811 175.943 402.912 176.774 403.12 177.58C403.273 178.25 403.621 178.859 404.12 179.33C404.678 179.797 405.394 180.034 406.12 179.99Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.011 181.35L423.411 160.4H416.581V158.76H425.501V159.76L420.991 181.35H419.011Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.18 346.42H131.16V439.06H233.18V346.42Z",
    fill: "#92E3A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M233.18 346.42H131.16V439.06H233.18V346.42Z",
    fill: "black",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.18 346.42H131.16V439.06H233.18V346.42Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.87 346.42H131.16V439.06H203.87V346.42Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.88 346.42H159.26V372.28H174.88V346.42Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.99 379.84H178.88V389.08H196.99V379.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.168 395.35L142.511 390.732L139.758 401.857L158.415 406.474L161.168 395.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.42 346.42H211.4V439.06H313.42V346.42Z",
    fill: "#92E3A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M313.42 346.42H211.4V439.06H313.42V346.42Z",
    fill: "black",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.42 346.42H211.4V439.06H313.42V346.42Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.11 346.42H211.4V439.06H284.11V346.42Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.12 346.42H239.5V372.28H255.12V346.42Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.83 416.63H251.72V425.87H269.83V416.63Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.398 395.353L222.741 390.736L219.988 401.86L238.645 406.477L241.398 395.353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.24 346.42H292.22V439.06H394.24V346.42Z",
    fill: "#92E3A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M394.24 346.42H292.22V439.06H394.24V346.42Z",
    fill: "black",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.24 346.42H292.22V439.06H394.24V346.42Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.93 346.42H292.22V439.06H364.93V346.42Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.93 346.42H320.31V372.28H335.93V346.42Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.75 387.398L345.681 374.861L339.285 381.529L352.353 394.066L358.75 387.398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.212 395.358L303.555 390.741L300.802 401.866L319.459 406.483L322.212 395.358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.85 254.22H172.83V346.86H274.85V254.22Z",
    fill: "#92E3A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M274.85 254.22H172.83V346.86H274.85V254.22Z",
    fill: "black",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.85 254.22H172.83V346.86H274.85V254.22Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.54 254.22H172.83V346.86H245.54V254.22Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.55 254.22H200.93V280.08H216.55V254.22Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.66 287.63H220.55V296.87H238.66V287.63Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.438 317.822L217.781 313.205L215.028 324.329L233.685 328.946L236.438 317.822Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.09 254.22H253.07V346.86H355.09V254.22Z",
    fill: "#92E3A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M355.09 254.22H253.07V346.86H355.09V254.22Z",
    fill: "black",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.09 254.22H253.07V346.86H355.09V254.22Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.78 254.22H253.07V346.86H325.78V254.22Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.79 254.22H281.17V280.08H296.79V254.22Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.29 288.97H287.18V298.21H305.29V288.97Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.07 303.144L264.413 298.526L261.66 309.651L280.317 314.268L283.07 303.144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3108 257.11C83.3108 257.11 88.1808 307.6 88.4808 314.59C88.7808 321.58 85.4808 325.23 85.4808 338.59C85.4808 351.95 88.8308 415.23 88.8308 415.23C88.8308 415.23 85.8308 432.87 84.5708 435.3C84.338 435.713 84.22 436.18 84.2289 436.653C84.2378 437.126 84.3733 437.588 84.6213 437.992C84.8694 438.395 85.2209 438.724 85.6393 438.946C86.0578 439.167 86.5279 439.272 87.0008 439.25H103.691C103.691 439.25 105.821 435.91 105.211 432.87C104.601 429.83 102.211 413.71 102.211 413.71C102.211 413.71 119.541 326.71 120.451 321.26C121.361 315.81 128.971 264.7 128.971 264.7L128.061 314.27C128.061 314.27 125.931 335.86 128.361 351.37C130.791 366.88 137.791 416.14 137.791 416.14L138.091 439.25H177.321C177.321 439.25 178.541 436.52 176.411 435C174.281 433.48 167.891 430.43 164.851 427.39C161.811 424.35 153.301 414.62 153.301 414.62C153.301 414.62 156.951 358.06 158.161 342.55C159.371 327.04 161.161 316.7 162.421 308.18C163.681 299.66 166.681 263.18 166.681 255.27C166.681 247.36 132.921 242.8 132.921 242.8L83.0508 247.97L83.3108 257.11Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.191 432.89C104.631 430.09 102.521 416.23 102.191 414.03H88.7208C88.7208 414.82 88.7908 415.25 88.7908 415.25C88.7908 415.25 85.7908 432.89 84.5308 435.32C84.2981 435.733 84.1801 436.2 84.1889 436.673C84.1978 437.146 84.3333 437.608 84.5814 438.012C84.8294 438.415 85.181 438.744 85.5994 438.966C86.0179 439.187 86.488 439.292 86.9608 439.27H103.681C104.411 438.063 104.922 436.736 105.191 435.35C105.345 434.537 105.345 433.703 105.191 432.89ZM176.741 435.35C176.629 435.234 176.505 435.131 176.371 435.04C174.241 433.53 167.861 430.48 164.811 427.45C161.761 424.42 153.261 414.67 153.261 414.67V414.61L137.491 414.35C137.651 415.5 137.751 416.14 137.751 416.14L138.001 435.3L138.051 439.25H177.281C177.281 439.25 178.351 436.87 176.741 435.35Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5308 435.35H105.191C104.922 436.746 104.408 438.084 103.671 439.3H86.9608C86.488 439.322 86.0179 439.217 85.5994 438.995C85.181 438.774 84.8294 438.445 84.5814 438.041C84.3333 437.638 84.1978 437.176 84.1889 436.703C84.1801 436.229 84.2981 435.762 84.5308 435.35Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.28 439.27H138.05L138 435.32H176.74C178.35 436.87 177.28 439.27 177.28 439.27Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.32 160.73L173.38 173.43L194.45 182.35L188.64 196.8C188.64 196.8 170.13 196.13 167.3 194.91C165.628 194.208 164.076 193.25 162.7 192.07L162.84 160.19L164.32 160.73Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.742 179.306L200.233 158.894L171.738 233.594L225.247 254.005L253.742 179.306Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.74 179.317L240.912 174.423L212.417 249.123L225.245 254.016L253.74 179.317Z",
    fill: "#92E3A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M253.74 179.317L240.912 174.423L212.417 249.123L225.245 254.016L253.74 179.317Z",
    fill: "black",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.74 179.317L240.912 174.423L212.417 249.123L225.245 254.016L253.74 179.317Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.801 162.49C210.801 162.49 215.251 160.6 215.801 161C216.351 161.4 216.741 164.92 216.741 164.92L210.801 162.49Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.801 161C215.801 161 219.711 161.41 220.521 162.76C221.331 164.11 220.521 166.68 220.521 166.68L216.741 164.92L215.801 161Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.521 162.76C220.521 162.76 223.361 162.89 223.771 163.98C224.052 165.22 224.186 166.489 224.171 167.76L220.521 166.68C220.521 166.68 221.471 164.11 220.521 162.76Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.771 163.98C223.771 163.98 227.141 163.57 227.551 165.73C227.795 166.931 227.839 168.165 227.681 169.38L224.191 167.76C224.191 167.76 224.581 164.52 223.771 163.98Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.261 258.69C167.085 259.746 162.765 260.11 158.471 259.77C151.691 259.15 141.061 252.52 141.061 252.52C141.061 252.52 120.721 259.92 105.471 262.23C96.074 263.559 86.4927 262.337 77.7308 258.69L79.7308 234.83L81.0508 219.01L82.2808 204.46L82.3508 203.54C82.3508 203.54 80.7808 197.23 78.9808 188.76C76.5108 177.22 73.6308 161.62 73.7208 152.39C73.8808 136.39 83.4308 131.39 83.4308 131.39L111.011 119.53C123.631 119.06 127.491 123.07 134.431 124.46C141.371 125.85 162.161 135.4 163.431 138.17C164.291 140.12 165.171 168.17 165.601 185.73C165.791 193.08 165.901 198.57 165.901 199.49C165.901 199.76 165.901 200.49 166.021 201.49C166.251 204.61 166.801 210.81 167.471 218.01C167.921 223.01 168.471 228.52 168.931 233.8C170.131 246.93 171.261 258.69 171.261 258.69Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3602 203.54C82.3602 203.54 80.7902 197.23 78.9902 188.76L165.57 185.76C165.76 193.11 165.87 198.6 165.87 199.52C165.87 199.79 165.87 200.52 165.99 201.52L82.2902 204.42L82.3602 203.54Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.9 233.87L79.7402 234.87L81.0602 219.05L167.44 218.12C167.89 223.09 168.41 228.59 168.9 233.87Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.881 186.86C139.881 186.86 142.311 227.31 140.181 249.81",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 109.4C150 109.4 151.69 124.03 152 125.4C152.31 126.77 149.07 127.4 143.52 126.79L137.98 126.17C137.98 126.17 141.21 120.47 142.14 118.93C143.07 117.39 150 109.4 150 109.4Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.44 126.19C136.367 127.893 136.471 129.599 136.75 131.28C137.21 134.51 139.36 161.63 139.06 165.17C138.76 168.71 138.59 169.95 138.59 169.95C138.59 169.95 129.35 147.76 122.88 138.05C116.41 128.34 113.33 123.73 113.02 122.96C112.71 122.19 111.94 99.96 111.94 99.96C111.94 99.96 115.94 101.35 117.79 104.43C119.64 107.51 125.34 113.98 129.35 118.43C133.36 122.88 136.44 126.19 136.44 126.19Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.941 118.71L134.501 134.44L136.941 132.98L137.981 126.19L122.551 113.42L124.941 118.71Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.661 136.05C127.081 136.97 116.071 124.9 112.851 121.23C112.864 121.81 112.921 122.388 113.021 122.96C113.331 123.73 116.411 128.35 122.881 138.05C129.351 147.75 138.591 169.95 138.591 169.95C138.591 169.95 138.751 168.71 139.061 165.17C139.331 161.99 137.621 139.83 136.941 132.98C135.576 134.569 133.716 135.65 131.661 136.05Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.54 90.29C153.54 90.29 151.69 101.08 151.69 103.7C151.69 106.32 151.84 110.01 147.99 115.41C144.14 120.81 140.9 126.35 138.75 127.12C137.236 127.54 135.641 127.577 134.108 127.228C132.576 126.879 131.154 126.154 129.97 125.12C127.04 122.66 119.64 111.41 118.72 110.33C118.031 109.43 117.459 108.446 117.02 107.4L114.87 104.94C114.87 104.94 110.55 103.55 110.87 98.16C110.892 96.6788 111.283 95.2265 112.01 93.9357C112.737 92.6448 113.775 91.5565 115.03 90.77L121.81 84.77C131.804 89.0872 142.676 90.9787 153.54 90.29Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.61 96.9199C146.61 96.9199 144.76 102.16 144.76 102.62C144.76 103.08 146.45 111.71 145.53 112.33C144.61 112.95 139.53 111.55 139.53 111.55",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.811 111.09C131.811 111.09 135.511 116.33 141.681 115.25",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.381 102C136.159 102 136.791 100.979 136.791 99.7199C136.791 98.4607 136.159 97.4399 135.381 97.4399C134.602 97.4399 133.971 98.4607 133.971 99.7199C133.971 100.979 134.602 102 135.381 102Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.091 102.89C149.869 102.89 150.501 101.869 150.501 100.61C150.501 99.3509 149.869 98.3301 149.091 98.3301C148.312 98.3301 147.681 99.3509 147.681 100.61C147.681 101.869 148.312 102.89 149.091 102.89Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.051 95.8401C133.956 95.1344 135.002 94.6316 136.118 94.3659C137.235 94.1001 138.395 94.0777 139.521 94.3001",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.19 95.07C148.863 94.8138 149.593 94.7502 150.3 94.8862C151.007 95.0222 151.661 95.3525 152.19 95.84",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.801 88.44C123.801 88.44 124.421 92.3 123.031 94.15C121.896 95.5258 120.603 96.7642 119.181 97.84C119.181 97.84 116.561 93.22 114.101 95.22C111.641 97.22 112.251 100.15 112.861 101.69C113.387 102.851 114.059 103.939 114.861 104.93L114.401 123.73C110.734 123.516 107.082 123.102 103.461 122.49C100.028 121.694 96.849 120.055 94.2106 117.72C94.098 113.016 94.9912 108.341 96.8306 104.01C98.82 99.3237 101.244 94.8341 104.071 90.6L105.921 83.21L123.801 88.44Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.79 83.6501C100.79 83.6501 127.65 91.2801 130.28 92.6501C132.91 94.0201 156.35 93.4401 159.77 91.6501C163.19 89.8601 157.66 85.3301 157.66 85.3301C157.66 85.3301 154.26 81.3901 154 80.0701C153.74 78.7501 154.55 65.3501 148.76 58.5001C142.97 51.6501 127.39 50.6901 120.57 52.0301C111.94 53.7201 105.01 60.3201 104.22 63.2101C103.43 66.1001 103.19 77.8601 102.9 78.6501C102.61 79.4401 100.79 83.6501 100.79 83.6501Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.4 165.48C167.4 165.48 169.1 160.39 170.64 160.24C172.18 160.09 176.34 163.17 177.57 162.4C178.8 161.63 183.43 151 182.5 148.99C181.57 146.98 162.17 140.52 159.55 140.99C156.93 141.46 152.15 163.18 152.15 163.18L167.4 165.48Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.81 146.79L173.28 161.1C174.96 161.89 176.82 162.87 177.57 162.4C178.81 161.63 183.43 151 182.5 148.99C182.27 148.49 180.84 147.69 178.81 146.79Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.191 163.47L160.541 141.01C160.209 140.965 159.872 140.965 159.541 141.01C156.921 141.47 152.141 163.2 152.141 163.2L154.191 163.47Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.131 173.95C136.131 173.95 152.191 161.35 152.611 161.35C153.031 161.35 168.481 163.51 169.101 165.51C169.52 166.811 169.52 168.21 169.101 169.51C168.951 169.98 167.561 170.59 167.101 170.9C166.641 171.21 164.791 178.3 162.941 179.99C161.091 181.68 160.161 182.15 157.081 181.69C154.565 181.133 152.131 180.252 149.841 179.07L139.841 182.76L136.131 173.95Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 181.96C103 181.96 91.9104 139.75 88.6804 135.9C85.4504 132.05 82.5104 130.97 76.5004 138.67C70.4904 146.37 73.5804 164.25 77.2704 182.27C80.9604 200.29 87.6004 210.62 89.6004 210.47C91.6004 210.32 140.9 184.47 140.9 184.47L136.9 172.91L103 181.96Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.77 182.73C100.055 183.083 98.4312 183.785 96.9997 184.793C95.5682 185.801 94.3599 187.094 93.4502 188.59",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.38 183.5C94.38 183.5 92.99 184.74 91.29 190.28",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_409_1507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 465,
    height: 440,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackagingImage);
export default __webpack_public_path__ + "static/media/PackagingImage.96f2a4787b0e419892e6a99d82b84eda.svg";
export { ForwardRef as ReactComponent };